module.exports = __webpack_public_path__ + "img/m3.a1db64d0.png";